import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const RejectDialog = ({ open, onClose, onConfirm, title }) => {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-[#1F293D] bg-[#111827]" data-testid="reject-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{title}</DialogTitle></DialogHeader>
        <Textarea data-testid="reject-reason-input" placeholder="Reason (shown to the member)" value={reason} onChange={(e) => setReason(e.target.value)} />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="reject-cancel-btn">Cancel</Button>
          <Button variant="destructive" onClick={() => { onConfirm(reason); setReason(""); }} data-testid="reject-confirm-btn">Reject</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
